import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";

export function AboutPage() {
  return (
    <main className="max-w-6xl mx-auto px-5 py-10">
      <SEO
        title="A propos"
        description="Le Cobaye teste les formations en ligne pour vous donner des avis honnetes. Decouvrez la methode d'evaluation et le pourquoi du projet."
        path="/a-propos"
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "A propos", path: "/a-propos" },
        ]}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "A propos de Le Cobaye",
          description:
            "Le Cobaye teste les formations en ligne pour vous donner des avis honnetes. Decouvrez la methode d'evaluation et le pourquoi du projet.",
          url: "https://le-cobaye.fr/a-propos",
          inLanguage: "fr",
          isPartOf: {
            "@type": "WebSite",
            name: "Le Cobaye",
            url: "https://le-cobaye.fr",
          },
        }}
      />

      <Breadcrumbs
        items={[
          { label: "Accueil", href: "/" },
          { label: "A propos" },
        ]}
      />

      <h1 className="text-xl font-bold tracking-tight mb-6">A propos</h1>

      <div className="prose">
        <p>
          <strong>Le Cobaye</strong>, c'est moi qui teste les formations en
          ligne pour que vous n'ayez pas a le faire.
        </p>

        <p>
          Trop de formations promettent monts et merveilles. Les avis en ligne
          sont biaises, sponsorises, ou ecrits par des gens qui n'ont jamais
          suivi le cours. Ici, chaque formation est reellement testee avant
          d'etre evaluee.
        </p>

        <h2>Comment je teste</h2>

        <p>
          Je suis le parcours complet (ou au minimum plusieurs modules),
          je prends des notes, et je donne mon avis. Pas de partenariat cache.
          J'evalue sur :
        </p>

        <ul>
          <li>La qualite du contenu</li>
          <li>Le rapport qualite-prix</li>
          <li>L'accompagnement</li>
          <li>La mise en pratique</li>
          <li>La valeur du certificat</li>
        </ul>

        <h2>Pourquoi "Le Cobaye" ?</h2>

        <p>
          Parce que je sers de cobaye. Je teste, j'essuie les platres, et je
          vous dis si ca vaut le coup. Simple.
        </p>
      </div>
    </main>
  );
}
